import _Object$keys from "@babel/runtime-corejs3/core-js/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js/object/get-own-property-symbols";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _reduceInstanceProperty from "@babel/runtime-corejs3/core-js/instance/reduce";
import _sliceInstanceProperty from "@babel/runtime-corejs3/core-js/instance/slice";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import _findInstanceProperty from "@babel/runtime-corejs3/core-js/instance/find";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState, mapGetters, mapActions } from "vuex";
import CollaboratorsSelect from "./shared/collaborators-select";
import CollaboratorItem from "./collaborator-item";
import { ADD_PROFILE_COLLABORATOR, REMOVE_PROFILE_COLLABORATOR, LOAD_PROFILE_COLLABORATORS } from "@Broker/@Modules/clients/board/store/board-actions";
import { COLLABORATORS } from "@Broker/@Modules/clients/board/store/board-getters";
import ProfileAvatar from "@Shared/components/general/profile-avatar";
import { debounce, filter } from "lodash";
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "ClientProfileCollaborators",
  components: {
    CollaboratorsSelect,
    CollaboratorItem,
    ProfileAvatar
  },
  props: {
    clientProfileId: {
      type: [String, Number],
      required: true
    },
    boardId: {
      type: [String, Number],
      required: true
    },
    profile: {
      type: Object,
      required: true
    }
  },
  computed: _objectSpread(_objectSpread(_objectSpread({}, mapGetters("BoardStore", [COLLABORATORS, "getProfileCollaborators"])), {}, {
    profileCollaborators() {
      return this.getProfileCollaborators({
        id: this.clientProfileId
      }) || [];
    }
  }, mapState("BoardStore", {
    collaborators(state) {
      const clientBoard = state.boards.byId[this.boardId];
      if (!clientBoard) return [];
      const boardCollaborators = this.COLLABORATORS(this.boardId);
      const boardCollaboratorsWithBoardOwner = _objectSpread(_objectSpread({}, boardCollaborators), {}, {
        [clientBoard.ownerDetails.username]: clientBoard.ownerDetails
      });
      const allCollaborators = filter(boardCollaboratorsWithBoardOwner, ({
        username
      }) => username !== this.details.owner.username);
      return _reduceInstanceProperty(allCollaborators).call(allCollaborators, (acc, collaborator) => {
        acc[collaborator.username] = collaborator;
        return acc;
      }, {});
    },
    normalizedCollaborators(state) {
      var _state$clientProfiles, _state$clientProfiles2;
      return (_state$clientProfiles = (_state$clientProfiles2 = state.clientProfiles.byId[this.clientProfileId]) == null ? void 0 : _state$clientProfiles2.collaborators) != null ? _state$clientProfiles : {
        byId: {},
        allIds: []
      };
    }
  })), {}, {
    currentCollaborators() {
      return this.normalizedCollaborators.allIds;
    },
    collaboratorsById() {
      return this.normalizedCollaborators.byId;
    },
    details() {
      return this.profile || {};
    },
    owner() {
      return _objectSpread(_objectSpread({}, this.details.owner), {}, {
        trackEmails: this.details.trackEmails
      });
    },
    firstThreeCollaborators() {
      var _context, _context2;
      return _sliceInstanceProperty(_context = _filterInstanceProperty(_context2 = [...this.profileCollaborators, this.owner]).call(_context2, ({
        trackEmails
      }) => trackEmails)).call(_context, 0, 3);
    },
    atLeastOneTrackingOn() {
      const atLeastOneCollaborator = this.profileCollaborators.some(({
        trackEmails
      }) => trackEmails);
      return atLeastOneCollaborator || this.owner.trackEmails;
    }
  }),
  activated() {
    this.LOAD_PROFILE_COLLABORATORS({
      id: this.clientProfileId
    });
  },
  created() {
    this.LOAD_PROFILE_COLLABORATORS({
      id: this.clientProfileId
    });
  },
  methods: _objectSpread(_objectSpread({}, mapActions("BoardStore", [LOAD_PROFILE_COLLABORATORS, ADD_PROFILE_COLLABORATOR, REMOVE_PROFILE_COLLABORATOR])), {}, {
    handleChange: debounce(function (data, type) {
      if (type === "select") {
        this.ADD_PROFILE_COLLABORATOR({
          id: this.clientProfileId,
          collaborator: this.collaborators[data.username] || this.details.owner
        });
      } else if (type === "unselect") {
        this.REMOVE_PROFILE_COLLABORATOR({
          id: this.clientProfileId,
          collaborator: this.collaboratorsById[data.username]
        });
      }
      this.$emit("add-remove-collaborator");
    }, 100),
    handleEmailTracking(username) {
      var _context3;
      const profile = _findInstanceProperty(_context3 = this.profileCollaborators).call(_context3, collaborator => collaborator.username === username);
      this.$emit("change", profile);
    }
  })
});